import { render, staticRenderFns } from "./RepositoryForm.vue?vue&type=template&id=bcf509e0&scoped=true&"
import script from "./RepositoryForm.vue?vue&type=script&lang=js&"
export * from "./RepositoryForm.vue?vue&type=script&lang=js&"
import style0 from "./RepositoryForm.vue?vue&type=style&index=0&id=bcf509e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf509e0",
  null
  
)

export default component.exports